/**
 * 财务--》请款结果
*/

export default {
    // 审批后补录图片
    upload_pictures_after_approval: ["99552", "83018"], // 202510281528595906063, 审批后补录图片功能放开
}
